import Button from "@/components/button/Button"
import SubmitButton from "@/components/button/SubmitButton"
import BackButton from "@/components/button/BackButton"

export default {
    install(Vue) {
        Vue.component("BackButton", BackButton)
        Vue.component("SubmitButton", SubmitButton)
        Vue.component("Button", Button)
    },
}
